import { createSlice } from "@reduxjs/toolkit";
import { stateEnum } from "../constants/enum";

const { purity } = stateEnum;

let initialState = {
    detailParams: {},
    isNewEntry: false
};


const puritySlice = createSlice({
    name: purity,
    initialState,
    reducers: {
        setNewEntryMode: (state, action) => {
            state.isNewEntry = action.payload;
        },
        setDetailParams: (state, action) => {
            state.detailParams = action.payload
          },
        resetDetail: (state) => {
            state.detailParams = {};
            state.isNewEntry = true;
        },
    },
    
});


export const { setNewEntryMode,setDetailParams, resetDetail } = puritySlice.actions;
export default puritySlice.reducer;
